import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../../components/common/HeroSection';
import SEO from '../../components/seo/SEO';
import PersonSchema from '../../components/seo/PersonSchema';

const About = () => {
  return (
    <div className="w-full">
      <SEO 
        title="Dyt. Nihal Kamış Hakkında - Diyetisyen Profili ve Eğitim Geçmişi"
        description="Diyetisyen Nihal Kamış'ın eğitim geçmişi, uzmanlık alanları ve misyonu hakkında bilgi. İstanbul Medipol Üniversitesi mezunu diyetisyen ile sağlıklı yaşam rehberliği."
        url="https://www.dytnihalkamis.com/about"
        keywords="diyetisyen hakkımda, nihal kamış biyografi, diyetisyen eğitim, medipol üniversitesi beslenme ve diyetetik"
      />
      <PersonSchema />
      
      {/* Page Header */}
      <HeroSection 
        title="Dyt. Nihal Kamış Hakkında" 
        subtitle="" 
      />

      <div className="section-padding bg-white">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 {*/items-center*/} mb-16">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img 
                src="/assets/placeholder-dietitian.png" 
                alt="Dyt. Nihal Kamış" 
                className="rounded-lg shadow-xl w-full"
              />
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-nihal-dark mb-4">Dyt. Nihal Kamış</h2>
              <p className="text-gray-600 mb-4">
				Diyetisyen Nihal Kamış, İstanbul Medipol Üniversitesi Beslenme ve Diyetetik Bölümü’nden dereceyle mezun olmuştur. Eğitim süresince Medipol Üniversitesi Hastaneleri ve Diyetisyen Merve Sayın Beslenme ve Diyet Eğitim Merkezi’nde staj yaparak uygulamalı deneyim kazanmıştır.
				</p>
				<p className="text-gray-600 mb-4">
				Gebe ve anne-çocuk beslenmesi, sporcu beslenmesi, bariyatrik cerrahi diyetisyenliği, obezite yönetimi ve hastalıklarda beslenme gibi alanlarda kapsamlı bilgi ve deneyime sahiptir. Spor beslenmesi kongresi ve çeşitli eğitim programlarına katılarak bilgilerini güncel tutmaktadır.
				</p>
				<p className="text-gray-600 mb-6">
				Son üç yıldır aktif olarak diyetisyenlik yapmaktadır. Bireylerin sağlıklı ve dengeli beslenme alışkanlıkları kazanmalarına destek olmaktadır.
				</p>
            </motion.div>
          </div>

          {/* Education */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-nihal-dark text-center mb-12">Eğitim & Sertifikalar</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 }}
                className="bg-nihal-secondary rounded-lg p-6"
              >
                <h3 className="text-xl font-bold text-nihal-dark mb-2">Diyetisten</h3>
                <p className="text-gray-600">Medipol Üniversitesi - (2018 - 2022)</p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="bg-nihal-secondary rounded-lg p-6"
              >
                <h3 className="text-xl font-bold text-nihal-dark mb-2">Spor Beslenmesi Kongresi</h3>
                <p className="text-gray-600">İzmir - 2025</p>
              </motion.div>
              
              {/*<motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 }}
                className="bg-nihal-secondary rounded-lg p-6"
              >
                <h3 className="text-xl font-bold text-nihal-dark mb-2">Diyabet Eğitimi Sertifikası</h3>
                <p className="text-gray-600">ISSN - 2024</p>
              </motion.div>*/}
            </div>
          </div>

          {/* Mission */}
          <div className="bg-nihal-primary bg-opacity-10 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <motion.div
			initial={{ opacity: 0, x: -50 }}
			whileInView={{ opacity: 1, x: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
			>
			<h2 className="text-3xl font-bold text-nihal-dark mb-6">Misyonum</h2>
			<p className="text-gray-700 mb-4">
				Amacım, kişilerin benzersiz ihtiyaçlarına, yaşam tarzlarına ve hedeflerine uygun, 
				kanıta dayalı beslenme rehberliğiyle sağlıklarını kontrol altına almalarını sağlamaktır.
			</p>
			<p className="text-gray-700 mb-4">
				Beslenme danışmanlığının kişiye özel, uygulanabilir ve sürdürülebilir olması gerektiğine inanıyorum. 
				Kısıtlayıcı diyetleri teşvik etmek yerine, danışanlarımın uzun vadede sürdürebileceği 
				dengeli yaklaşımlar geliştirmeye odaklanıyorum.
			</p>
			<p className="text-gray-700">
				Eğitim, destek ve sürekli rehberlik aracılığıyla, danışanlarımın yiyeceklerle olumlu bir ilişki 
				kurmalarına ve kalıcı sağlık iyileşmeleri elde etmelerine yardımcı oluyorum.
			</p>
			</motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="text-center"
              >
                <div className="bg-nihal-primary w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-nihal-dark mb-4">Kanıta Dayalı Yaklaşım</h3>
                <p className="text-gray-700">
                  Tüm önerilerim bilimsel araştırmalara ve klinik kanıtlara dayanmaktadır.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;